const BYTE_ARRAY_INTERVAL = 33;

export const constants = {
	BYTE_ARRAY_INTERVAL
};

export default constants;
